import { http } from '../api/http';

export type BankAccountStatus = 'PENDING' | 'VERIFIED' | 'REJECTED' | 'DISABLED';

export type AdminBankAccount = {
  id: string;
  status: BankAccountStatus;
  accountType: string;
  beneficiaryName: string;
  clabeMasked?: string | null;
  currency: string;
  isDefault: boolean;
  createdAt: string;
  verifiedAt?: string | null;
  bank?: {
    id: string;
    name: string;
    code: string;
  } | null;
  user?: {
    id: string;
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
  } | null;
};

export const AdminBankAccountsService = {
  list(params?: { status?: BankAccountStatus; q?: string }) {
    const query = new URLSearchParams();
    if (params?.status) query.set('status', params.status);
    if (params?.q) query.set('q', params.q);
    const qs = query.toString();
    return http<AdminBankAccount[]>(`/admin/bank-accounts${qs ? `?${qs}` : ''}`);
  },

  verify(id: string) {
    return http(`/admin/bank-accounts/${id}/verify`, { method: 'PATCH' });
  },
};
